import React, { PropsWithChildren, useRef } from "react";
import styled from "styled-components";
import lang from "../functions/lang";
import { useGoogle } from "../Hooks/useGoogle";
import { Store } from "../interfaces/IStore";
import XIcon from "./Icons/XIcon";
import { StoreContent } from "./StoreContent";
const Card = styled.div<{ isOpen: boolean }>`
  position: absolute;
  z-index: 2;
  padding-top: 5.4rem;
  bottom: 0;
  top: 0;
  left: ${(props) => (props.isOpen ? "23rem" : "2rem")};
  overflow: hidden;
  display: flex;
  flex-flow: column;
  transition: 0.3s;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  flex-shrink: 1;
  border-top-right-radius: 1.6rem;
  width: 20rem;
  box-shadow: 0 1px 7px 0 rgb(0 0 0 / 20%);
  bottom: 0;
  position: relative;
  overflow: hidden;
  background: white;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  padding: 1rem 1.5rem 1rem 1rem;
`;

const Header = styled.h4`
  margin: 0;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: -0.5px;
  color: #522398;
`;

const CardContentWrapper = styled.div`
  padding: 1rem;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  ::-webkit-scrollbar {
    border-radius: 30px;
  }
`;

const CardFooterWrapper = styled.div`
  bottom: 0;
  left: 0;
  right: 0;
  flex-grow: 0;
  flex-shrink: 0;
  background-color: #fff;
  position: absolute;
  padding: 1rem;
  display: flex;
  flex-direction: column;
`;

const A = styled.a`
  color: #522398;
  font-size: 18px;
  text-decoration: none;
  padding-left: 11px;
`;

let MoreInfoContainer = styled.div``;

interface IStoreCard {
  currentStore: Store | undefined;
  showStore: boolean;
  closeStore: () => void;
}

const StoreCard = ({
  currentStore,
  showStore,
  closeStore,
}: PropsWithChildren<IStoreCard>) => {
  const StoreModalOuterRef = useRef() as React.MutableRefObject<HTMLDivElement>;

  return (
    //@ts-ignore
    <Card ref={StoreModalOuterRef} isOpen={showStore && currentStore}>
      <CardContent toggleStore={closeStore} currentStore={currentStore} />
    </Card>
  );
};

interface ICardContent {
  currentStore: Store | undefined;
  toggleStore: () => void;
}

const CardContent = ({
  currentStore,
  toggleStore,
}: PropsWithChildren<ICardContent>) => {

  return (
    <CardWrapper>
      {/* Close Icon */}
      <HeaderWrapper>
        <Header>
          {lang("storeCard.header", window.data?.language || "en")}
        </Header>

        <XIcon onClick={toggleStore} />
      </HeaderWrapper>
      <CardContentWrapper>
        <StoreContent currentStore={currentStore}/>
      </CardContentWrapper>
      {/*<CardFooterWrapper>
        <MoreInfoContainer>
          {currentStore?.business_type === "airbnb" &&
          currentStore?.airbnb_id ? (
            <A
              href={`https://${window.data?.language === "fr"?"fr":"www"}.airbnb.ca/rooms/${currentStore?.airbnb_id}`}
              target={"blank"}>
              {lang("storeCard.view_airbnb", window.data?.language || "en")}
            </A>
          ) : (
            (currentStore?.url_fr ||
              currentStore?.url ||
              (currentStore?.google_id && googleData?.storeUrl)) && (
              <A
                href={
                  window.data?.language === "fr" && currentStore?.url_fr
                    ? currentStore.url_fr
                    : currentStore?.url
                    ? currentStore.url
                    : googleData?.storeUrl
                }
                target={"blank"}>
                {lang("storeCard.more_info", window.data?.language || "en")}
              </A>
            )
          )}
        </MoreInfoContainer>
      </CardFooterWrapper>*/}
    </CardWrapper>
  );
};

export default StoreCard;
